var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('banner',{attrs:{"type":"7"}}),_c('productList',{attrs:{"recommend-show":false,"product-list":_vm.petList,"product-name":"宠物检测"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }